'use client';

import ImpTracker from '@/components/common/ImpTracker';
import useImpressionT2 from '@/tracks/useImpressionT2';

import { CmsSsrComponentProps, ISize } from '@/types/cms';
import LayoutCenter from './layout-center';
import LayoutLeft from './layout-left';
import LayoutStack from './layout-stack';
import Container from '../Container';
import { twMerge } from 'tailwind-merge';

export interface FeatureHeaderProperties {
  title?: string;
  sub_title?: string;
  description?: string;
  icon?: string;
  pc_media?: string;
  mobile_media?: string;
  background?: string;
  layout?: 'left' | 'center' | 'inline' | 'stack';
  font_size?: ISize; // small | middle | large
  title_style?: string; // JSON string
  sub_title_style?: string; // JSON string
  description_style?: string; // JSON string
  vertical_margin?: 'none' | 'small' | 'middle' | 'large';
  horizontal_margin?: 'none' | 'small' | 'middle' | 'large';
  alias?: string;
  visibility_rule?: string;
  event_key?: string;
}

export default function FeatureHeader({
  properties = {},
  componentInstanceKey,
  componentKey,
  top,
  componentPosition,
  trackingContext
}: Readonly<CmsSsrComponentProps>): React.ReactElement {
  const { bannerImpression } = useImpressionT2();
  const { layout = 'left', event_key, mobile_media } = properties as FeatureHeaderProperties;
  return (
    <Container
      componentKey={componentKey}
      componentInstanceKey={componentInstanceKey}
      properties={properties}
      top={top}>
      <ImpTracker
        impTrackingT2={() => {
          bannerImpression({
            mod_nm: event_key ?? componentKey,
            mod_pos: componentPosition,
            ctx: trackingContext
          });
        }}
        className={twMerge(mobile_media ? 'py-5' : '')}>
        {layout === 'left' && <LayoutLeft properties={properties} />}
        {layout === 'center' && <LayoutCenter properties={properties} />}
        {layout === 'inline' && <LayoutLeft properties={properties} />}
        {layout === 'stack' && (
          <>
            {mobile_media && <LayoutStack properties={properties} />}
            {/* 如果没有pc_media，则使用left布局 */}
            {!mobile_media && <LayoutLeft properties={properties} />}
          </>
        )}
      </ImpTracker>
    </Container>
  );
}
